export default function getNodeType (name) {

  if (name == "Task") {return "BizNode"}
  if (name == "Call") {return "CallNode"}
  if (name == "Bot") {return "BotNode"}
  if (name == "REST") {return "RESTNode"}

  if (name.indexOf("Mouse") != -1) {return "MouseNode"}
  if (name.indexOf("Click") != -1) {return "MouseNode"}
  if (name.indexOf("Move") != -1) {return "MouseNode"}

  if (name == "File") {return "FileNode"}
  if (name == "If") {return "IfNode"}
  if (name == "Key") {return "KeyNode"}
  if (name == "KeyInsert") {return "KeyNode"}
  if (name == "LoopImageMatch") {return "LoopNode"}
  if (name == "Wait") {return "WaitNode"}
  if (name == "Speaker") {return "SpeakerNode"}
  if (name == "SpeechToText") {return "SpeechToTextNode"}
  if (name.startsWith("Browser")) {return "BrowserNode"}
  return 'RegularNode'

};

